var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ChatCTABody, ChatCTACard, IconWrapper } from './subcomponents';
const ChatCTA = (_a) => {
    var { children, onClick, color } = _a, props = __rest(_a, ["children", "onClick", "color"]);
    return (React.createElement(ChatCTACard, Object.assign({ color: color, onClick: onClick }, props),
        React.createElement(IconWrapper, { color: color },
            React.createElement(FontAwesomeIcon, { icon: ['fal', 'comments'], size: "3x" })),
        React.createElement(ChatCTABody, null, children)));
};
export default ChatCTA;
